import Methods from '../Methods';
import INumericCounter from '../Models/INumericCounter';
import ResponseMode, { ReturnTypeByMode } from '../ResponseMode';
import Transport, { ITransport } from '../Transports';
import IQueryNumericCounterRequest from '../Requests/IQueryNumericCounterRequest';
import IPatchNumericCounterRequest from '../Requests/IPatchNumericCounterRequest';
import { ensureResponseMode } from '@/utils/utils';
import IQueryService from './IQueryService';
import ICreateNumericCounterRequest from '../Requests/ICreateNumericCounterRequest';
const baseUri = '/api/v1/numeric-counters';

class NumericCounterService implements IQueryService<IQueryNumericCounterRequest, INumericCounter> {
    private _transport: ITransport;

    constructor(transport: ITransport) {
        this._transport = transport;
    }

    public queryAsync(request?: IQueryNumericCounterRequest): Promise<INumericCounter[]> {
        return this._transport.invokeAsync<IQueryNumericCounterRequest, INumericCounter[]>(
            Methods.Get,
            baseUri,
            request,
        );
    }

    public createAsync<T extends ResponseMode = 'status'>(
        request: ICreateNumericCounterRequest,
        responseMode: T = 'status' as T,
    ): Promise<ReturnTypeByMode<INumericCounter, T>> {
        return this._transport.invokeAsync<ICreateNumericCounterRequest, ReturnTypeByMode<INumericCounter, T>>(
            Methods.Post,
            `${baseUri}?_rm=${ensureResponseMode(responseMode)}`,
            request,
        );
    }

    public patchAsync<T extends ResponseMode = 'status'>(
        id: number,
        request: IPatchNumericCounterRequest,
        responseMode: T = 'status' as T,
    ): Promise<ReturnTypeByMode<INumericCounter, T>> {
        return this._transport.invokeAsync<IPatchNumericCounterRequest, ReturnTypeByMode<INumericCounter, T>>(
            Methods.Patch,
            `${baseUri}/${id}?_rm=${ensureResponseMode(responseMode)}`,
            request,
        );
    }
}

const service = Object.freeze(new NumericCounterService(Transport));
export default service;
